export default __webpack_public_path__ + "static/media/EWG1.9b23701d.png";